import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#EEE7F3',
  light: '#7A4A9A',
  main: '#522377',
  dark: '#36195B',
  darker: '#24103F',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#EAF3FA',
  light: '#5D8DB5',
  main: '#2F6FA5',
  dark: '#133155',
  darker: '#080B38',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#EAF3FA',
  light: '#69A2D0',
  main: '#2F6FA5',
  dark: '#1D527F',
  darker: '#080B38',
  contrastText: '#fff',
};
const WARNING = {
  lighter: '#FFF4DD',
  light: '#D88A13',
  main: '#A15D05',
  dark: '#7A4705',
  darker: '#7A2D04',
  contrastText: '#fff',
};


const SUCCESS = {
  lighter: '#E7F7F3',
  light: '#0F9D86',
  main: '#087765',
  dark: '#065C50',
  darker: '#064E45',
  contrastText: '#fff',
};

const ORANGE = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FDECEF',
  light: '#DC6276',
  main: '#B63D54',
  dark: '#923044',
  darker: '#7D2638',
  contrastText: '#fff',
};

const PINK = {
  lighter: '#FFE0E6',
  light: '#FFB6C1',
  main: '#FF69B4',
  dark: '#DB7093',
  darker: '#8B008B',
  contrastText: '#fff',
};


const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  orange:ORANGE,
  error: ERROR,
  pink:PINK,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: '#080B38',
    secondary: '#133155',
    disabled: '#76859A',
  },
  background: {
    paper: '#fff',
    default: '#F4F6FA',
    neutral: '#EDF1F6',
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
